module.exports = __webpack_public_path__ + "media/images/konintodoke/top_recommend/fall-right-icon-0f14af45d98373dc69e5330d0d2eed90.svg";